import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";
import { homeStoreSelectors } from "../../home/store/store";

function* getGameBundles(action) {
    try {
        const gameBundles = yield call(() =>
            gamesAPI.getGameBundles({
                skip: (action.payload.page - 1) * action.payload.top,
                top: action.payload.top,
                search: action.payload.search
            })
        );

        yield put({
            type: GamesActionTypes.GET_BUNDLES_SUCCESS,
            payload: {
                gameBundles: gameBundles.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game bundles list.");

        yield put({
            type: GamesActionTypes.GET_BUNDLES_FAIL,
            message: e.message
        });
    }
}

export function* getGameBundlesWatcher() {
    yield takeLatest(GamesActionTypes.GET_BUNDLES, getGameBundles);
}
